export default {
  name: 'marking--docP',
  apiService: 'shoes',
  apiPath: '/admin/doc_p',
};
